import { useNavigate } from 'react-router-dom';
import { ActionButton } from '../../components/vertical-dot/popper';

interface EmailTemplateHeaderProps {
  actions: Record<string, any>[];
  navigate: ReturnType<typeof useNavigate>;
}

interface CellProps {
  row: any;
  cell: any;
  handleRowEdit?: any;
}

interface Action {
  action: string;
  onClick: (id: any, rowData: any) => void;
}

const EmailTemplateHeader = ({ actions, navigate }: EmailTemplateHeaderProps) => {
  const handleEdit = (id: any, notificationType: any) => {
    navigate(`/email-template/edit/`, {
      state: {
        id,
        notificationType,
      },
    });
  };

  const renderCell = ({ row, cell, ...rest }: CellProps) => {
    return (
      <td>
        <ActionButton
          actions={[
            {
              action: 'Edit',
              onClick: (id: string, rowData: any) => {
                handleEdit(rowData.id, rowData.notificationType);
              },
            },
          ]}
          id={row.original.id}
          rowData={row.original}
          counter={parseInt(row?.id)}
        />
      </td>
    );
  };

  const newActions = [
    ...(actions || []).map((col: any) => {
      if (col.accessor === 'notificationType') {
        return {
          ...col,
          isModalField: true,
          popoverInfo: 'EmailTemplate',
          fields: { id: 'id' },
        };
      }
      return col;
    }),
    {
      accessor: 'actions',
      width: 20,
      sortable: false,
      renderCell: true,
      isSubHeader: false,
      Cell: renderCell,
    },
  ];

  return newActions;
};

export default EmailTemplateHeader;
